import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { ChevronDown, Coins } from "lucide-react";
import { useAuthUser } from "@/context/auth/AuthContext";
import useGetWarehousesRest from "@/hooks/react-query/Warehouses/useGetWarehousesRest";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { LoadingContainerStyled } from "@/components/loading/LoadingContainer";
import Loading from "@/components/loading/Loading";
import SecondaryText from "@/components/SecondaryText";
import CashdeskWarehouseCard from "./cashdesk-warehouse-card/CashdeskWarehouseCard";
import React from "react";
import { useCashdeskStore } from "@/context/cashdesk/CashdeskContext";

function OpenCashdesk() {
  const user = useAuthUser();
  const [open, setOpen] = React.useState(false);
  const isOpen = useCashdeskStore.use.isOpen();
  const onClose = useCashdeskStore.use.onClose();

  const warehouseFilter = [
    {
      fieldName: "id",
      operation: null,
      value: "desc",
      type: null,
      operator: "order_by",
    },
    {
      fieldName: "deleted",
      operation: "_eq",
      variableName: "$isDeleted",
      variableValue: false,
      type: "Boolean",
      operator: "where",
    },
    {
      fieldName: "deleted",
      operation: "_eq",
      variableName: "$isDeleted",
      variableValue: false,
      type: "Boolean",
      operator: "whereAggregate",
    },
  ];

  const { warehouses, items: warehouseItems } = useGetWarehousesRest(
    warehouseFilter,
    !!user,
    user?.type !== "owner" ? ["limited"] : ["all"],
    false,
    false,
    user?.type !== "owner"
  );

  const isOwner = user?.type === "owner";
  const assignedWarehouses: string[] = user?.assignedWarehouses || [];
  const visibleWarehouses = isOwner
    ? warehouseItems
    : warehouseItems.filter((w: any) => assignedWarehouses.includes(w.id));

  return (
    <>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button type="button" variant="muted" className="w-7 h-7">
            <ChevronDown />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="p-0 m-1 overflow-hidden">
          <div className="grid">
            <div
              className="flex gap-2 cursor-pointer hover:bg-background-200 transition p-3"
              onClick={() => {
                useCashdeskStore.getState().onOpen();
                setOpen(false);
              }}
            >
              <Coins className="icon" />
              Abrir/cerrar cajas
            </div>
          </div>
        </PopoverContent>
      </Popover>

      <Dialog open={isOpen} onOpenChange={onClose}>
        <DialogContent className="sm:max-w-[425px]">
          <DialogHeader>
            <DialogTitle>Abrir o cerrar caja</DialogTitle>
            <DialogDescription>
              Aquí puedes abrir y cerrar las cajas de tus locales de manera
              rápida y directa.
            </DialogDescription>
          </DialogHeader>
          <div>
            {warehouses.isLoading && (
              <LoadingContainerStyled>
                <Loading />
              </LoadingContainerStyled>
            )}

            {warehouses.isSuccess && visibleWarehouses.length > 0 ? (
              <div className="flex flex-col gap-2.5">
                {visibleWarehouses.map((warehouse: any) => (
                  <CashdeskWarehouseCard key={warehouse.id} local={warehouse} />
                ))}
              </div>
            ) : (
              <SecondaryText>No se encontraron locales...</SecondaryText>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default OpenCashdesk;
